module.exports = "/img/service-1.730c7881.png";